import React, { createContext, useContext, useState, useEffect } from 'react';

const UIContext = createContext();

const styles = {
  small: {
    inputStyle: {
      padding: '2px 4px',
      fontSize: '0.72rem'
      
    },
    textStyle: {
      fontSize: '0.82rem',
      lineHeight: '1.4'
    }
  },
  medium: {
    inputStyle: {
      padding: '3px 6px',
      fontSize: '0.88rem'
    },
    textStyle: {
      fontSize: '0.98rem',
      lineHeight: '1.4'
    }
  },
  large: {
    inputStyle: {
  padding: '4px 8px',
  fontSize: '0.98rem',
  minWidth: '140px'
},
textStyle: {
  fontSize: '1.06rem',
  lineHeight: '1.4'
}

  }

};

export function UIProvider({ children, initialUiSize }) {
  const [uiSize, setUiSize] = useState(null);

  useEffect(() => {
    if (initialUiSize) {
      setUiSize(initialUiSize);
    }
  }, [initialUiSize]);

  useEffect(() => {
    if (!uiSize) return;
    document.body.setAttribute('data-ui-size', uiSize);
    localStorage.setItem('uiSize', uiSize);
  }, [uiSize]);




  useEffect(() => {
    const handler = () => {
      //if (window.innerWidth < 600) setUiSize('large');
      //else setUiSize('medium');
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    document.body.setAttribute('data-ui-size', uiSize);
  }, [uiSize]);

  return (
  <UIContext.Provider value={{ uiSize, setUiSize: (size) => {
    setUiSize(size);
    localStorage.setItem('uiSize', size);
  }}}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  const size = styles[context.uiSize] || styles.medium;

  const cardStyle = {
    backgroundColor: 'var(--import-bg)',
    color: 'var(--text-primary)',
    border: '1px solid var(--card-border)',
    borderRadius: '10px',
    padding: '10px'
  };

  const abcEditorStyle = {
    backgroundColor: 'var(--input-bg)',
    color: 'var(--input-text, var(--text-primary))',
    padding: '8px',
    borderRadius: '6px',
    border: '1px solid var(--card-border)',
    fontFamily: 'monospace',
    lineHeight: '1.4',
    resize: 'none'
  };

  return {
    ...context,
    inputStyle: size.inputStyle,
    textStyle: size.textStyle,
    cardStyle,
    abcEditorStyle
  };
}
